import React from 'react';
import { motion } from 'framer-motion';
import { DatabaseIcon, FilterIcon } from 'lucide-react';
type ResultsCounterProps = {
  total: number;
  filtered: number;
  isSearchActive: boolean;
};
export function ResultsCounter({
  total,
  filtered,
  isSearchActive
}: ResultsCounterProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} className="bg-slate-800/30 border border-slate-700/50 rounded-2xl p-8 backdrop-blur-sm" data-id="element-313">
      <div className="flex items-center justify-center gap-4 mb-6" data-id="element-314">
        <div className="p-3 bg-amber-500/10 rounded-xl" data-id="element-315">
          {isSearchActive ? <FilterIcon className="w-8 h-8 text-amber-500" data-id="element-316" /> : <DatabaseIcon className="w-8 h-8 text-amber-500" data-id="element-317" />}
        </div>
      </div>

      <div className="text-center" data-id="element-318">
        <motion.div key={filtered} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-2" data-id="element-319">
          <span className="text-6xl font-bold text-white tabular-nums" data-id="element-320">
            {filtered.toLocaleString()}
          </span>
        </motion.div>

        <p className="text-slate-400 text-lg" data-id="element-321">
          {isSearchActive ? <>
              companies match your criteria
              <span className="text-slate-500 block text-sm mt-1" data-id="element-322">
                out of {total.toLocaleString()} total
              </span>
            </> : <>
              companies in database
              <span className="text-slate-500 block text-sm mt-1" data-id="element-323">
                Use search to filter results
              </span>
            </>}
        </p>
      </div>

      {filtered > 50 && isSearchActive && <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} className="text-center text-amber-500/80 text-sm mt-4 pt-4 border-t border-slate-700/50" data-id="element-324">
          Refine your search to view detailed results (≤50 companies)
        </motion.p>}
    </motion.div>;
}